import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // To get the article ID from URL
import './ArticleDetailPage.css';

const ArticleDetailPage = () => {
  const { id } = useParams(); // Get the article ID from the URL
  const [article, setArticle] = useState(null); // State to store the article details
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error handling

  useEffect(() => {
    // Fetch the article details
    const fetchArticleDetails = async () => {
      try {
        const response = await fetch(`https://newsapi.org/v2/everything?q=anime&apiKey=bc0f4bfb97ba454c93c778701dbaa1a2`);
        const data = await response.json();
        
        // Find the article by ID (Assuming `id` is unique for each article)
        const selectedArticle = data.articles.find(item => item.title === id); // Find the article by its title (or use another unique identifier)
        
        // If article not found
        if (!selectedArticle) {
          throw new Error('Article not found');
        }

        setArticle(selectedArticle);
        setLoading(false);
      } catch (err) {
        setError(err.message); // Set error message if fetch fails
        setLoading(false);
      }
    };

    fetchArticleDetails(); // Fetch the article when the component mounts
  }, [id]); // Re-fetch when the ID changes

  // Show loading while fetching the article
  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // Show error message if fetching fails
  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <section className="article-detail-page">
      {/* Article Content */}
      <div className="article-content">
        <h1 className="article-title">{article?.title}</h1>
        <p className="article-author">By: {article?.author || 'Unknown'}</p>
        <p className="article-date">{article?.publishedAt}</p>
        <div className="article-body">
          <p>{article?.content}</p>
        </div>
      </div>

      {/* Comments Section */}
      <div className="comments-section">
        <h2>Comments</h2>
        <div className="comment-box">
          <textarea placeholder="Leave a comment..."></textarea>
          <button>Submit</button>
        </div>
        <div className="comments-list">
          <div className="comment">
            <p><strong>User1</strong>: Great article!</p>
          </div>
          <div className="comment">
            <p><strong>User2</strong>: Very informative. Thanks for sharing!</p>
          </div>
        </div>
      </div>

      {/* You May Also Like Section */}
      <div className="related-articles">
        <h2>You May Also Like</h2>
        <div className="related-articles-list">
          {/* This is mock data. Replace with actual related articles */}
          <div className="related-article">
            <img src="https://via.placeholder.com/150" alt="Related Article" />
            <p>Related Article 1</p>
          </div>
          <div className="related-article">
            <img src="https://via.placeholder.com/150" alt="Related Article" />
            <p>Related Article 2</p>
          </div>
          <div className="related-article">
            <img src="https://via.placeholder.com/150" alt="Related Article" />
            <p>Related Article 3</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArticleDetailPage;
